import React, { useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  Step,
  StepLabel,
  Stepper,
  LinearProgress,

  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import { useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import PersonalInformation from "./components/PersonalInformation";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../../../context/auth";
import Swal from "sweetalert2";

const AddComponent = () => {
  const navigate = useNavigate();
  const {
    componentdisplay,
    setfielddisable,
    setTogglePage,
    togglePage,
    AccessData,
  } = useUserDetails();
  const [editdisplay, seteditdisplay] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [activeStep, setActiveStep] = useState(0); //Used to store current step
  const steps = ["Personal info", "Employee info", "Bank Details"]; // Used to store getSteps functionality in a variable

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [componentData, setComponentData] = useState({
    componentName: "",
    abbreviation: "",
    componentType: {},
    description: "",
    calculatedFrom: {},
    calculatedIn: {},
    dependsOnPaymentDays: false,
    statisticalComponent: false,
    taxApplicable: false,
    removeIfZero: false,
    fullTaxOnPayrollDate: false,
    includeFromTotal: false,
    roundToInteger: false,
    disabled: false,
    componentNameStatus: "",
    abbreviationStatus: "",
    componentTypeStatus: "",
    descriptionStatus: "",
    calculatedFromStatus: "",
    calculatedInStatus: "",
  });

  const [id, setId] = useState(null);
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getComponentMasterById(id);
    }else {
       setPageState((prevState) => ({
              ...prevState,
              loading: false,
              state: "default",
            }));
    }
  }, []);

  const [originalComponentData, setOriginalComponentData] = useState(null);

  const getComponentMasterById = async (id) => {
      setPageState({
          ...pageState,
          loading: true,
          state: "init",
        });
    const query = `
            query getComponentMasterById($id: String!) {
                componentmasterById(id: $id) {
                    id
                    componentName
                    abbreviation
                    type
                    description
                    calculatedFrom
                    calculatedIn
                    dependsOnPaymentDays
                    statisticalComponent
                    taxApplicable
                    removeIfZero
                    fullTaxOnPayrollDate
                    includeFromTotal
                    roundToInteger
                    disabled
                }
            }`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: { id },
        }),
      });

      const component = response.data.data.componentmasterById;
      console.log("component:", component);

      const updatedComponentData = {
        componentName: component.componentName || "",
        abbreviation: component.abbreviation || "",
        componentType: {value:component.type,label:component.type},
          // resources.componentType.find((opt) => opt.label === component.type) || {}, 
        description: component.description || "",
        calculatedFrom:
          resources.calculatedFrom.find(
            (opt) => opt.value === component.calculatedFrom
          ) || {},
        calculatedIn:
          resources.calculatedIn.find(
            (opt) => opt.value === component.calculatedIn
          ) || {},
        dependsOnPaymentDays: component.dependsOnPaymentDays || false,
        statisticalComponent: component.statisticalComponent || false,
        taxApplicable: component.taxApplicable || false,
        removeIfZero: component.removeIfZero || false,
        fullTaxOnPayrollDate: component.fullTaxOnPayrollDate || false,
        includeFromTotal: component.includeFromTotal || false,
        roundToInteger: component.roundToInteger || false,
        disabled: component.disabled || false,
        // Add additional status fields if needed
        componentNameStatus: "",
        abbreviationStatus: "",
        componentTypeStatus: "",
        descriptionStatus: "",
        calculatedFromStatus: "",
        calculatedInStatus: "",
      };

      setComponentData(updatedComponentData);
      setOriginalComponentData(updatedComponentData); // Store original data

      setTogglePage({
        ...togglePage,
        view: true,
      });
       setPageState((prevState) => ({
              ...prevState,
              loading: false,
              state: "default",
            }));

      return componentData;
    } catch (error) {
      console.error("Error fetching component data:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const [resources, setResources] = useState({
    salutation: [
      { value: "Mr.", label: "Mr." },
      { value: "Ms.", label: "Ms." },
      { value: "Mrs.", label: "Mrs." },
      { value: "Dr.", label: "Dr." },
    ],
    componentType: [
      { value: "Earnings", label: "Earning" },
      { value: "Deductions", label: "Deductions" },
      { value: "Benefits", label: "Benefits" },
    ],
    calculatedIn: [
      { value: "amount", label: "Amount" },
      { value: "percentage", label: "Percentage" },
    ],
    calculatedFrom: [
      { value: "CTC", label: "CTC" },
      { value: "Basic", label: "Basic" },
      { value: "Gross", label: "Gross" },
      { value: "Benifit", label: "Benefit" },
    ],
    reportManager: [
      { value: "manager1", label: "Manager1" },
      { value: "manager2", label: "Manager2" },
    ],
    employeeType: [
      { value: "type1", label: "Type1" },
      { value: "type2", label: "Type2" },
    ],
    department: [
      { value: "department1", label: "Department1" },
      { value: "department2", label: "Department2" },
    ],
    designation: [
      { value: "designation1", label: "Designation1" },
      { value: "designation2", label: "Designation2" },
    ],
  });

  const handleComponentDataChange = (event, selectEvent) => {
    let employeeState = { ...componentData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "componentType") {
        const lengthRegex = new RegExp("^[A-Za-z 0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "calculatedFrom") {
        const lengthRegex = new RegExp("^[A-Za-z 0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "calculatedIn") {
        const lengthRegex = new RegExp("^[A-Za-z 0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      employeeState[selectEvent.name] = event;
    } else if (typeof selectEvent === "boolean") {
      employeeState[event.target.name] = selectEvent;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "componentName":
          {
            const alphaNLengthRegex = /^([a-z A-Z]{1,20})$/;

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "abbreviation":
          {
            const alphaNLengthRegex = new RegExp("^([a-z A-Z]{1,25})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "description":
          {
            const alphaNumberLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,250}$"
            );
            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        default:
          break;
      }
      if (changeAllowed) {
        employeeState[event.target.name] = event.target.value;
      }
    }
    setComponentData(employeeState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      componentData.componentNameStatus === "success" &&
      componentData.abbreviationStatus === "success" &&
      componentData.componentTypeStatus === "success" &&
      componentData.calculatedFromStatus === "success" &&
      componentData.calculatedInStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const isFormValid =
    componentData.componentNameStatus === "success" &&
    componentData.abbreviationStatus === "success" &&
    componentData.componentTypeStatus === "success";

  const handleAddComponent = () => {
    if (checkAllFields()) {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          onComponentSubmit();
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // Function to move the next step
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  // Function to move the previous step
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const onComponentSubmit = async () => {
    const query = `
mutation AddComponentMaster($input: ComponentmasterInput!) {
  AddComponentMaster(input: $input) {
    componentmaster {
      id
      componentName
      abbreviation
      type
      description
      calculatedFrom
      calculatedIn
      dependsOnPaymentDays
      statisticalComponent
      taxApplicable
      removeIfZero
      fullTaxOnPayrollDate
      includeFromTotal
      roundToInteger
      disabled
      lastUpdate
    }
  }
}


`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              componentName: componentData.componentName,
              abbreviation: componentData.abbreviation,
              type: componentData.componentType?.value,
              calculatedFrom: componentData.calculatedFrom?.value,
              calculatedIn: componentData.calculatedIn?.value,
              description: componentData.description,
              dependsOnPaymentDays: componentData.dependsOnPaymentDays,
              statisticalComponent: componentData.statisticalComponent,
              taxApplicable: componentData.taxApplicable,
              removeIfZero: componentData.removeIfZero,
              fullTaxOnPayrollDate: componentData.fullTaxOnPayrollDate,
              includeFromTotal: componentData.includeFromTotal,
              roundToInteger: componentData.roundToInteger,
              disabled: componentData.disabled,
              // Include other fields as necessary
            },
          },
        }),
      });

      const result = response.data.data.AddComponentMaster.componentmaster;

      if (result !== " ") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Component Submited successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      navigate("/component");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteComponentSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteComponentSubmit = async () => {
    const query = `
       mutation delete($id:Int!){
  deleteComponentmaster(id:$id){
		success
  }
}
    `;
    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteComponentmaster.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Component Deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/component");
      } else {
        console.log(
          "Error deleting designation:",
          response.data.data.deleteDesignation.message
        );
        setConfirmationDialog({
          open: true,
          title: "Error massage",
          message:
            "Sorry for your inconvience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,

          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
    }
  };

  const Oneditcomponent = async () => {
    const query = `mutation EditComponentMaster(
  $id: Int!,
  $input: ComponentmasterInput!
) {
  EditComponentMaster(id: $id, input: $input) {
    componentmaster {
      id
      componentName
      abbreviation
      type
      description
      calculatedFrom
      calculatedIn
      dependsOnPaymentDays
      statisticalComponent
      taxApplicable
      removeIfZero
      fullTaxOnPayrollDate
      includeFromTotal
      roundToInteger
      disabled
      lastUpdate
    }
  }
}`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            input: {
              componentName: componentData.componentName,
              abbreviation: componentData.abbreviation,
              type: componentData.componentType?.value,
              description: componentData.description,
              calculatedFrom: componentData.calculatedFrom?.value,
              calculatedIn: componentData.calculatedIn?.value,
              dependsOnPaymentDays: componentData.dependsOnPaymentDays,
              statisticalComponent: componentData.statisticalComponent,
              taxApplicable: componentData.taxApplicable,
              removeIfZero: componentData.removeIfZero,
              fullTaxOnPayrollDate: componentData.fullTaxOnPayrollDate,
              includeFromTotal: componentData.includeFromTotal,
              roundToInteger: componentData.roundToInteger,
              disabled: componentData.disabled,
            },
          },
        }),
      });

      if (response.data.data.EditComponentMaster) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Component Updated successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/component");
      } else {
        throw new Error("Failed to update component");
      }
    } catch (error) {
      console.error("Error updating component:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDiscardDesignation = () => {
    if (originalComponentData) {
      setComponentData(originalComponentData); // Reset to original data
    }
    seteditdisplay(false);
    setTogglePage({
      view: true,
      edit: false,
    });
  };

  const handleedit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    seteditdisplay(true);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
    
       
          
            {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Component details for you. This may
                    take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <MaterialTypography variant="h5" fontWeight="medium">
                  Add Component Details
                </MaterialTypography>
              </Stack>
      
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "EditComponent" && item.can_access
                ) &&
                componentdisplay && (
                  <ButtonGroup variant="outlined" aria-label="Loading button group">
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleedit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
      
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={AddDelete}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton>
                  </ButtonGroup>
                )}
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "60vh" }}>
          <MaterialBox>
            <PersonalInformation
              componentData={componentData}
              handleComponentDataChange={handleComponentDataChange}
              resources={resources}
            />
          </MaterialBox>
        </CardContent>
        <CardActions>
          
        </CardActions>
        <MaterialBox display="flex" justifyContent="flex-end" alignItems="center">
          {!componentdisplay && (
            <MaterialButton
              variant="gradient"
              color="dark"
              sx={{ m: 2 }}
              disabled={!checkAllFields()}
              onClick={handleAddComponent}
            >
              Submit
            </MaterialButton>
          )}
        </MaterialBox>
      
        <CardActions>
          <MaterialBox p={3} mt={3} width="100%" display="flex" justifyContent="end">
            {editdisplay && (
              <>
                <MaterialButton variant="gradient" color="dark" onClick={onDiscardDesignation}>
                  Discard
                </MaterialButton>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  style={{
                    maxWidth: "115px",
                    minWidth: "120px",
                    marginLeft: "2%",
                  }}
                  onClick={Oneditcomponent}
                >
                  Update
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </CardActions>
      </Card>
      
      )}
            
       
    </DashboardLayout>
  );
};

export default AddComponent;
